import { Colors, IconButton } from 'react-native-paper';
import styled from 'styled-components/native';

import DropDown from '@src/components/DropDown';
import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import Popover from '@src/components/Popover';
import ReadMoreContent from '@src/components/ReadMoreContent';
import RowBase from '@src/components/Row';
import { Body1, H3 } from '@src/components/Typography';
import VideoBase from '@src/components/Video';
import { likeColor, padding } from '@src/configuration/constants';

type Size = {
  width: number;
  height: number;
};

export const Container = styled.View`
  overflow: hidden;
`;

export const IconsRow = styled(RowBase)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-horizontal: ${padding / 2}px;
`;

export const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
  align-items: center;
`;

export const Photo = styled(Image).attrs({
  resizeMode: 'cover',
})<Size>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

export const Thumbnail = styled(ImageBackground).attrs({
  resizeMode: 'cover',
})<Size>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

export const MediaContainer = styled.View<Size>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background-color: ${Colors.black};
`;

export const Video = styled(VideoBase)<Size>`
  position: absolute;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  align-items: stretch;
`;

export const JourneyButton = styled(IconButton).attrs(({ theme }) => ({
  color: theme.colors.text,
  icon: require('@src/assets/images/journey.png'),
  size: 18,
}))``;

export const JourneyText = styled(H3)`
  color: ${({ theme }) => theme.colors.primary};
`;

export const ExtendedContent = styled(Body1)`
  padding: 5px 10px 0 10px;
`;

export const CommentIconButton = styled(IconButton).attrs(({ theme }) => ({
  color: theme.colors.placeholder,
  icon: 'comment-alt-o',
}))``;

export const MoreOptionsIconButton = styled(IconButton).attrs(({ theme }) => ({
  color: theme.colors.placeholder,
  icon: 'ellipsis-v-o',
  size: 17,
}))`
  width: 120px;
  align-items: flex-end;
`;

type HeartIconButtonProps = {
  liked?: boolean;
};

export const LikeIconButton = styled(IconButton).attrs<HeartIconButtonProps>(
  ({ liked, theme }) => ({
    color: liked ? likeColor : theme.colors.placeholder,
  })
)<HeartIconButtonProps>``;

export const Content = styled(ReadMoreContent)`
  padding-bottom: 0;
  padding-horizontal: 10px;
  padding-top: 5px;
`;

export const MoreOptions = styled(Popover)``;

export const RightIcons = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const LeftIcons = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ReportPicker = styled(DropDown).attrs(() => ({
  multiSelect: false,
  mode: 'outlined',
  inputProps: {
    dense: true,
    style: {
      fontSize: 12,
      minWidth: 120,
    },
  },
  iconSize: 12,
}))``;
